import { environmentConfig } from '../config/environment';

export interface CategorizedItems {
    outerwear: string[];
    top: string[];
    bottom: string[];
    shoes: string[];
    accessory: string[];
    other: string[];
}

export interface ProductInput {
    id: string; // SKU or ID
    title: string;
    description?: string;
    category?: string;
}

class FashMatchService {

    /**
     * Categorizes basket items via the backend API.
     */
    public async categorizeBasketItems(items: any[]): Promise<CategorizedItems> {
        try {
            console.log('FashMatchService: categorizeBasketItems called with:', items);

            // Map basket items to simpler product structure
            // Support items which might be directly product objects or basket items wrapping products
            const products = items.map(item => {
                // Handle different structures (BasketItem, direct Product, or API response)
                const p = item.product || item;

                // EXTENSIVE MAPPING to handle various data structures from host sites
                const id = p.sku || p.id || p._id || p.productId || p.product_id || p.code || p.itemCode || '';
                const title = p.name || p.title || p.productName || p.product_name || p.label || p.description || '';
                const description = p.description || p.shortDescription || p.short_description || p.details || '';
                const category = p.category || p.productCategory || p.product_category || p.categoryId || '';

                if (!id || !title) {
                    console.warn('FashMatchService: Invalid item mapped:', { original: item, mapped: { id, title } });
                }

                return { id, title, description, category };
            }).filter(p => {
                const isValid = p.id && p.title;
                if (!isValid) console.warn('FashMatchService: Filtered out item:', p);
                return isValid;
            });

            console.log('FashMatchService: Mapped products to send:', products);

            // Backend API URL
            // Adjust property access based on actual environment config structure
            // Assuming validationApi or a generic api base is appropriate if fash-mirror is not explicitly listed
            const baseUrl = environmentConfig.api.validationApi.replace('/validation', '') || environmentConfig.api.productsApi;

            // Note: In a real scenario, check exactly how environmentConfig maps to base URL. 
            // The implementation plan assumes /api/v1/fash-mirror/categorize-basket
            // The environment config usually points to /api/v1.

            // Updated route: /api/v1/ai/categorize-basket
            const response = await fetch(`${baseUrl}/ai/categorize-basket`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Add default brand ID if needed, or rely on optional auth for now
                    // 'x-brand-id': '...', 
                },
                body: JSON.stringify({ products }),
            });

            if (!response.ok) {
                throw new Error(`Categorization failed: ${response.statusText}`);
            }

            const result = await response.json();

            if (!result.success) {
                throw new Error(result.error || 'Categorization failed');
            }

            return result.data;

        } catch (error) {
            console.error('FashMatchService Error:', error);
            // Return empty structure on error to prevent crashing, let UI handle empty state
            return {
                outerwear: [],
                top: [],
                bottom: [],
                shoes: [],
                accessory: [],
                other: []
            };
        }
    }
}

const fashMatchServiceInstance = new FashMatchService();
export default fashMatchServiceInstance;
